import styled from 'styled-components';
import { COLOR, SPACING } from '../../constants/theme';

export const BrandName = styled.span`
  color: ${COLOR.primary};
`;

export const HeroImage = styled.div`
  margin: 0 auto ${SPACING.xxl};
  text-align: center;

  img {
    width: 58%;
    max-width: 320px;
  }
`;
